define [], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./dropdown.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      scope.update = (choice) ->
        scope.field.value = choice.value
        scope.selected_option = choice.value
      
      option = _.find(scope.field.choices, {'value': scope.field.value})
      scope.selected_option = option

      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/dropdown/dropdown.coffee